import { Injectable } from '@angular/core';
import { SecretService } from './secret.service';

import { format, getDay, isAfter, isBefore } from 'date-fns';
import * as moment from 'moment-timezone';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class OOHService {

    private jsOrderedDays = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
    private dayList = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
    private dayListExtended = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

    constructor(private secretService: SecretService, public translate: TranslateService) { }

    public getOfficeHours(): OpeningHours[] {

        const arrayDays: OpeningHours[] = [];

        if (!!this.portalSetttings && this.portalSetttings.jServiceHours
            && this.portalSetttings.jServiceHours.aAvailability && this.portalSetttings.jServiceHours.sDefaultTimezone) {

            const openingHours = this.portalSetttings.jServiceHours.aAvailability;

            openingHours.forEach((openingHour) => {
                openingHour.days.forEach((day) => {
                    const nowDate = format(new Date(), 'yyyy-MM-dd');
                    const fmt = 'YYYY-MM-DD HH:mm';

                    const openingUtcDate = moment.tz(`${nowDate} ${openingHour.timeFra}`,
                        fmt, this.portalSetttings.jServiceHours.sDefaultTimezone).toDate();
                    const closingUtcDate = moment.tz(`${nowDate} ${openingHour.timeTil}`,
                        fmt, this.portalSetttings.jServiceHours.sDefaultTimezone).toDate();

                    arrayDays.push({
                        day,
                        openingHour: openingUtcDate,
                        closingHour: closingUtcDate
                    });
                });
            });

            this.dayList.forEach((day) => {
                const availableDay = arrayDays.find((openDay) => openDay.day === day);
                if (!availableDay) {
                    arrayDays.push({
                        day,
                        openingHour: null,
                        closingHour: null
                    });
                }
            });

        }

        return !!arrayDays && arrayDays.length
            ? this.dayList
                .map((d) => {
                    const day = arrayDays.find(v => v.day.toLowerCase() === d.toLowerCase());
                    return day ? day : {
                        day: null,
                        openingHour: null,
                        closingHour: null
                    };
                })
            : arrayDays;

    }

    public hasOrderCreationOOH(): boolean {
        return !!this.portalSetttings && this.portalSetttings.bOutOfficeHoursCreateOrder;
    }

    public hasASAPTimeOOH(): boolean {
        return !!this.portalSetttings && this.portalSetttings.bOutOfficeHoursAsap;
    }

    public isOOH(): boolean {

        const dayHours = this.getTodayHours();

        if (dayHours) {
            const now = new Date();
            return !isAfter(now, dayHours.openingHour) || !isBefore(now, dayHours.closingHour);
        }

        return true;

    }

    public isIOH(): boolean {
        return !this.isOOH();
    }

    public getTodayHours(): OpeningHours {
        const dayWeek = getDay(new Date());
        const dayName = this.jsOrderedDays[dayWeek];
        const arrayDays = this.getOfficeHours();
        const dayHours = arrayDays.find(e => e.day === dayName);

        return dayHours;
    }

    get portalSetttings(): any {
        return this.secretService.getPortalSettings() ? this.secretService.getPortalSettings() : null;
    }

    public getExtendedDayString(dayCode: string): string {
        return this.translate.instant(`generic_${dayCode.toLowerCase()}`);
    }

}

export interface OpeningHours {
    day: string;
    openingHour: Date;
    closingHour: Date;
}
